import React from 'react';
import PropTypes from 'prop-types';
import BaseStyle from '../styled/BaseStyle';

const Season = ({ season }) => (
  <BaseStyle data-cy="single-product-season" fontSize="13px">
    {season}
  </BaseStyle>
);

Season.propTypes = {
  season: PropTypes.string.isRequired,
};

export default Season;
